import React from 'react';
import AboutDueDate from '../DueDate/AboutDueDate';
import CalculatorBox from '../DueDate/CalculatorBox';

export default function index({ stopRedirection, showVideo }) {
  return (
    <div>
      <CalculatorBox />
      <AboutDueDate showVideo={showVideo} stopRedirection={stopRedirection} />
      {/* <Articles /> */}
    </div>
  );
}
